import { useCallback, useState } from 'react';

export const useExpandedRowKeys = () => {
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);

  const clearExpandedRowKeys = useCallback(() => {
    setExpandedRowKeys([]);
  }, []);

  const addExpandedRowKeys = useCallback((keys: string[]) => {
    setExpandedRowKeys((expandedRowKeys) =>
      Array.from(new Set([...expandedRowKeys, ...keys])),
    );
  }, []);

  const removeExpandedRowKeys = useCallback((keys: string[]) => {
    setExpandedRowKeys((expandedRowKeys) =>
      expandedRowKeys.filter((k) => !keys.includes(k)),
    );
  }, []);

  const onExpand = useCallback((expanded: boolean, key: string) => {
    if (expanded) {
      setExpandedRowKeys((expandedRowKeys) =>
        Array.from(new Set([...expandedRowKeys, key])),
      );
    } else {
      setExpandedRowKeys((expandedRowKeys) =>
        expandedRowKeys.filter((k) => k !== key),
      );
    }
  }, []);

  return {
    expandedRowKeys,
    setExpandedRowKeys,
    addExpandedRowKeys,
    removeExpandedRowKeys,
    onExpand,
    clearExpandedRowKeys,
  };
};
